"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_CLASS_NAME = "mdc-typography";
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/typography/lib/constants.js
// module id = ./node_modules/@react-mdc/typography/lib/constants.js
// module chunks = 1 2 3